angular.module('app.entity.menu').provider('EntityMenuConfig', function() {
    this.structure = {};
    this.pluginNames = [
        'EntityMenuPluginCompletion',
        'EntityMenuPluginVisitCompletion',
        'EntityMenuPluginExpand',
        'EntityMenuPluginListItems',
        'EntityMenuPluginPendingChanges',
        'EntityMenuPluginValidation',
        'EntityMenuPluginVisibility',
    ];
    this.plugins = [];

    this.$get = ['$injector', 'AccountManager', function($injector, AccountManager) {
        for (var index in this.pluginNames) {
            var pluginName = this.pluginNames[index];

            var addPlugin = pluginName !== 'EntityMenuPluginRevisionStates'
                || AccountManager.hasPermission('read records revision');

            if (addPlugin) {
                this.plugins.push($injector.get(this.pluginNames[index]));
            }
        }

        return this;
    }];
});
